import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropbox-start',
  templateUrl: './dropbox-start.component.html',
  styleUrls: ['./dropbox-start.component.css']
})
export class DropboxStartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
